export default function ServersController(
  $q,
  $rootScope,
  $scope,
  confirmDialog,
  alerts,
  loaderService,
  userService,
  bcpDataService,
  editServerDialog,
  deleteServersDialog,
  ssDialogService,
) {
  const vm = this;

  vm.handleAdd = _handleAdd;
  vm.handleDelete = _handleDelete;
  vm.handleSynchronizeFromEndpointManagement = _handleSynchronizeFromEndpointManagement;
  vm.handleImportedServers = _handleImportedServers;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleAdd($event) {
    ssDialogService.dialogs.bcp.editServerDialog = ssDialogService.alert(
      editServerDialog.getOptions($event, {
        customerId: vm.customerId,
        assessmentId: vm.assessmentId,
        server: {
          assessmentId: vm.assessmentId,
          assessmentServerId: -1,
        },
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editServerDialog);
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.deleteServersDialog = ssDialogService.alert(
      deleteServersDialog.getOptions($event, {
        assessmentId: vm.assessmentId,
        servers: vm.servers,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.deleteServersDialog);
  }

  function _handleSynchronizeFromEndpointManagement($event) {
    if (vm.hasDatto) {
      _confirmSynchronizeFromDatto($event);
    } else {
      _confirmSynchronizeFromNetComply($event);
    }
  }

  function _confirmSynchronizeFromDatto($event) {
    bcpDataService.getDattoServerCount().then(response => {
      const count = response.data;
      ssDialogService.dialogs.bcp.confirmImportServersFromEndpointManagementDialog = ssDialogService.alert(
        confirmDialog.getOptions($event, {
          dialogTitle: 'Synchronize Servers with Endpoint Management?',
          warningMessage: `Synchronizing "Servers" with Endpoint Management will delete the existing inventory in your BCMP.`,
          message: `Do you want to continue with syncing your ${count} servers?`,
          handleYesClick: _performSynchronizeFromDatto,
          handleNoClick: _closeConfirmImportFromEndpointManagementDialog,
        }),
      );

      ssDialogService.show(ssDialogService.dialogs.bcp.confirmImportServersFromEndpointManagementDialog);
    });
  }

  function _confirmSynchronizeFromNetComply($event) {
    bcpDataService.getNetComplyServerCount().then(response => {
      const count = response.data;
      ssDialogService.dialogs.bcp.confirmImportServersFromEndpointManagementDialog = ssDialogService.alert(
        confirmDialog.getOptions($event, {
          dialogTitle: 'Synchronize Servers with Endpoint Management?',
          warningMessage: `Synchronizing "Servers" with Endpoint Management will delete the existing inventory in your BCMP.`,
          message: `Do you want to continue with syncing your ${count} servers?`,
          handleYesClick: _performSynchronizeFromNetComply,
          handleNoClick: _closeConfirmImportFromEndpointManagementDialog,
        }),
      );

      ssDialogService.show(ssDialogService.dialogs.bcp.confirmImportServersFromEndpointManagementDialog);
    });
  }

  function _performSynchronizeFromDatto($event) {
    return bcpDataService.synchronizeServersFromDatto(vm.assessmentId).then(
      result => {
        loaderService.showViewLoader = true;
        if (result.data) {
          loaderService.showViewLoader = false;
          alerts.success('The Endpoint Management Server synchronization was successful.');
          $rootScope.$broadcast('setDocumentRegenerateFlag');
          $rootScope.$broadcast('refreshBCPServers');
          _closeConfirmImportFromEndpointManagementDialog();
        } else {
          loaderService.showViewLoader = false;
          alerts.error('Error occurred synchronizing Endpoint Management Server(s).');
        }
      },
      () => {
        alerts.error('Error occurred synchronizing Endpoint Management Server(s).');
      },
    );
  }

  function _performSynchronizeFromNetComply($event) {
    return bcpDataService.synchronizeServersFromNetComply(vm.assessmentId).then(
      result => {
        loaderService.showViewLoader = true;
        if (result.data) {
          loaderService.showViewLoader = false;
          alerts.success('The Endpoint Management Server synchronization was successful.');
          $rootScope.$broadcast('setDocumentRegenerateFlag');
          $rootScope.$broadcast('refreshBCPServers');
          _closeConfirmImportFromEndpointManagementDialog();
        } else {
          loaderService.showViewLoader = false;
          alerts.error('Error occurred synchronizing Endpoint Management Server(s).');
        }
      },
      () => {
        alerts.error('Error occurred synchronizing Endpoint Management Server(s).');
      },
    );
  }

  function _closeConfirmImportFromEndpointManagementDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmImportServersFromEndpointManagementDialog);
  }

  function _handleImportedServers(newServers) {
    $rootScope.$broadcast('setDocumentRegenerateFlag');
    $rootScope.$broadcast('refreshBCPServers');
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {}

  function _initPermissions() {
    vm.canExpand = vm.serevrStatus !== '0 Servers Added';

    return userService.getUserPermissionSet('bcp').then(permissions => {
      vm.permissions = permissions;
    });
  }
}

ServersController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'confirmDialog',
  'alerts',
  'loaderService',
  'userService',
  'bcpDataService',
  'editServerDialog',
  'deleteServersDialog',
  'ssDialogService',
];
